export default "__VITE_ASSET__HSk_Qblp__"